<template>
<div class="chapter">
<div class="inner_page">
<p class="fmtitle"><a id="page_ix">CONTENTS</a></p><a id="page_ix">
<table cellpadding="0" cellspacing="0" width="100%">
<colgroup><col width="20%"/>
<col width="80%"/>
</colgroup><tbody><tr>
<td valign="top">
</td><td valign="top"><p class="toc1"><a href="#/xhtml/08_Fm02"><i>Note on Transliteration</i></a></p></td>
</tr>
<tr>
<td valign="top">
</td><td valign="top"><p class="toci"><a href="#/xhtml/10_Introduction">Introduction</a></p></td>
</tr>
<tr>
<td valign="top"><p class="tocr"><span href="#/xhtml/11_Chapter01" title="Link target outside of Sample"><i>one</i></span></p></td>
<td valign="top"><p class="toc"><span href="#/xhtml/11_Chapter01" title="Link target outside of Sample">Transnational Suspicions: Marriage and Changing Gender Roles</span></p></td>
</tr>
<tr>
<td valign="top"><p class="tocr"><span href="#/xhtml/12_Chapter02" title="Link target outside of Sample"><i>two</i></span></p></td>
<td valign="top"><p class="toc"><span href="#/xhtml/12_Chapter02" title="Link target outside of Sample">Reproduce: Changing Conceptions of Reproduction and Infertility</span></p></td>
</tr>
<tr>
<td valign="top"><p class="tocr"><span href="#/xhtml/13_Chapter03" title="Link target outside of Sample"><i>three</i></span></p></td>
<td valign="top"><p class="toc"><span href="#/xhtml/13_Chapter03" title="Link target outside of Sample">Labor: Migration and the Informal Market</span></p></td>
</tr>
<tr>
<td valign="top"><p class="tocr"><span href="#/xhtml/14_Chapter04" title="Link target outside of Sample"><i>four</i></span></p></td>
<td valign="top"><p class="toc"><span href="#/xhtml/14_Chapter04" title="Link target outside of Sample">Consume: The End of the Mediterranean Diet</span></p></td>
</tr>
<tr>
<td valign="top"><p class="tocr"><span href="#/xhtml/15_Chapter05" title="Link target outside of Sample"><i>five</i></span></p></td>
<td valign="top"><p class="toc"><span href="#/xhtml/15_Chapter05" title="Link target outside of Sample">Dwell: Urban Nostalgia as Neoliberal Critique</span></p></td>
</tr>
<tr>
<td valign="top">
</td><td valign="top"><p class="toc1"><span href="#/xhtml/16_Conclusion" title="Link target outside of Sample">Conclusion</span></p></td>
</tr>
<tr>
<td valign="top">
</td><td valign="top"><p class="toci"><span href="#/xhtml/17_Appendix01" title="Link target outside of Sample"><i>Appendix: Glossary of Terms</i></span></p></td>
</tr>
<tr>
<td valign="top">
</td><td valign="top"><p class="toci"><span href="#/xhtml/18_Bibliography" title="Link target outside of Sample"><i>Bibliography</i></span></p></td>
</tr>
<tr>
<td valign="top">
</td><td valign="top"><p class="toci"><span href="#/xhtml/19_Index01" title="Link target outside of Sample"><i>Index</i></span></p></td>
</tr>
</tbody></table>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_Contents.vue?473abca2